import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getCommonUrl } from '../../../components/common/common-functions/commonApiUrl/get-common-url';
import getConfig from '../../../helpers/config';
import {
  AuditResponse,
  AuditUrlType,
} from '../../../interfaces/audit-interface';
import {
  PaginationProps,
  PaginationReturn,
} from '../../../interfaces/pagination';
import { getPrepareHeaders } from '../get-prepare-headers';

const { test } = getConfig();
export interface UsersParams extends Partial<PaginationProps> {
  email: string;
  aktiv?: boolean;
  sort: 'asc' | 'desc';
  vitiFillimit?: string;
}

export const auditApi = createApi({
  reducerPath: 'audit',
  baseQuery: fetchBaseQuery({
    baseUrl: test.baseUrl + '/',
    prepareHeaders: getPrepareHeaders,
  }),
  tagTypes: ['allAudits'],
  keepUnusedDataFor: 0,
  endpoints: builder => ({
    getAudits: builder.query<PaginationReturn<AuditResponse>, AuditUrlType>({
      query: args => getCommonUrl(args, 'audit', 'data'),
      providesTags: ['allAudits'],
    }),
  }),
});

export const { useGetAuditsQuery } = auditApi;
